import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'order-keywords-addon',
  template: `
    <button class="btn btn-primary btn-block" (click)="onSearchOrder.emit()" [busyButton]="busy" [bbPreventDisable]="true" id="search-button-trigger" [disabled]="!orderKeywords() || busy">
      <i class="fa fa-search"></i>&nbsp;<span translate>APP.TICKET.BUTTONS.SEARCH</span>
    </button>
  `
})
export class OrderKeywordsAddonComponent {
  @Input() public orderKeywords: () => string;
  @Input() public busy: boolean;
  @Output() public onSearchOrder: EventEmitter<void> = new EventEmitter<void>();
}